var $ = require('jquery');

var $delayTime = 1000;
 
$(window).on('load', function(){
  var $loadingAnim = $('#loading'),
      $body = $('body');
 
    setTimeout( function(){
        
      $body.addClass('loaded');
  
      $loadingAnim.find('.loading__bg').on('transitionend', function( e ){ 
        $(this).parent().remove(); }); }, $delayTime );
});

var $header = $('#header');
// Nav Toggle Button
$('#toggle').on('click', function(){
    $header.toggleClass('is-open');
});